<template>
  <button class="ss__button" @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'SsButton2'
}
</script>

<style lang="stylus" scoped>
.ss__button {
  position: relative
  &:not([type="text"])::before {
    content: ''
    display: block
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    border-radius: inherit
    background: rgba(255, 255, 255, 0.2)
    opacity: 0
    transition: .2s
    z-index: 0
  }
  &:not(:disabled):hover::before {
    opacity: 1
  }
  &:hover {
  }
  & > span {
  }
}
</style>
